import * as types from "../actions/actionTypes";
import update from "immutability-helper";

// Start with coaches as an empty array and pagination metadata
export default function coaches(state = { coaches: [], pages: 1, pagination: {} }, action) {
  switch (action.type) {
    case types.ADD_COACHES:
      return {
        coaches: action.coaches,
        pages: action.pages || 1,
        pagination: action.pagination || {},
      }

    case types.CREATE_COACH:
      return {
        ...state,
        coaches: action.coach ? [Object.assign({}, action.coach), ...state.coaches] : state.coaches,
      }

    case types.UPDATE_COACH:
      // eslint-disable-next-line no-case-declarations
      const currentCoachIndex = state.coaches.findIndex(
        coach => coach.id === action.coach.id
      )
      // eslint-disable-next-line no-case-declarations
      const newCoach = action.coach
      return {
        ...state,
        coaches: update(state.coaches, {
          [currentCoachIndex]: { $set: newCoach },
        }),
      }

    default:
      return state;
  }
}
